var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !(_vm.fieldName === "pan" && !_vm.isVisible)
    ? _c(
        _vm.comp,
        _vm._b(
          {
            tag: "component",
            staticClass: "kr-icon-wrapper-root",
            style: { display: _vm.isVisible ? "flex" : "none" },
          },
          "component",
          _vm.dynamicAttributes,
          false
        ),
        [
          _vm.hasCustomIcon
            ? _c(
                "div",
                {
                  staticClass: "kr-icon kr-custom-icon",
                  style: _vm.css,
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c("div", { staticClass: "kr-icon-wrapper" }, [
                    _c("div", { staticClass: "kr-icon-wrapper-content" }, [
                      _c("i", { class: _vm.iconClass }),
                    ]),
                  ]),
                ]
              )
            : _vm.selectedBrand
            ? _c(
                "div",
                {
                  staticClass: "kr-icon",
                  class: _vm.dynamicClasses.icon,
                  style: _vm.css,
                  attrs: { "aria-hidden": (!_vm.brand).toString() },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "kr-icon-wrapper",
                      class: _vm.dynamicClasses.iconWrapper,
                    },
                    [
                      _c("div", { staticClass: "kr-icon-inner-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "kr-icon-wrapper-content" },
                          [
                            _c("SvgImage", {
                              attrs: {
                                title: _vm.brand,
                                decorative: !_vm.brand,
                                template: _vm.icon,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }